import { useState, useEffect } from "react";
import { List, X } from "@phosphor-icons/react";
import { LOGO, NAV_KEYS } from "../data";
import { useLang } from "../i18n/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Navbar() {
  const { t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,border-color] duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-gray-200 shadow-sm"
          : "bg-white/40 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <a href="#top" data-testid="navbar-logo-link" className="flex items-center">
          <img src={LOGO} alt="JA! Consulting & Support" className="h-9 sm:h-10 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV_KEYS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.key}`}
              className="text-[15px] font-medium text-[#0A0D1F] hover:text-[#4a90d9] transition-colors duration-200"
            >
              {t.nav[l.key]}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <LanguageSwitcher />
          <a
            href="#kontakt"
            data-testid="navbar-cta-button"
            className="inline-flex items-center rounded-full bg-[#1e2a6e] px-6 py-2.5 text-sm font-semibold text-white hover:bg-[#4a90d9] transition-colors duration-200"
          >
            {t.nav.cta}
          </a>
        </div>

        <div className="md:hidden flex items-center gap-3">
          <LanguageSwitcher />
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="text-[#1e2a6e]"
            aria-label="Menu"
          >
            {open ? <X size={28} weight="bold" /> : <List size={28} weight="bold" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-white border-t border-gray-200 px-5 py-5 space-y-4">
          {NAV_KEYS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-lg font-medium text-[#0A0D1F]"
            >
              {t.nav[l.key]}
            </a>
          ))}
          <a
            href="#kontakt"
            onClick={() => setOpen(false)}
            className="block text-center rounded-full bg-[#1e2a6e] px-6 py-3 text-base font-semibold text-white"
          >
            {t.nav.cta}
          </a>
        </div>
      )}
    </header>
  );
}
